<!--宗教立户-------------------------------------------------------------------->
<template>
    <div>
        <p class="title">立户单位基本信息</p>
        <van-cell-group>
            <van-field required label="场所名称" v-model="userInfo.csmc" placeholder="请输入场所名称"
                       input-align="right"/>
            <!--单位地址--------------------------------------------------------------->
            <van-field v-model="userInfo.hjdz1" label="场所地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerHJProvince = true"/>
            <van-popup v-model="showPickerHJProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title"
                            @cancel="showPickerHJProvince = false"
                            @confirm="onConfirmHJProvince"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerHJCity = true" v-if="HJCityShow"/>
            <van-popup v-model="showPickerHJCity" position="bottom">
                <van-picker :columns="cityHJList" show-toolbar value-key="title" @cancel="showPickerHJCity = false"
                            @confirm="onConfirmHJCity"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerHJArea = true" v-if="HJAreaShow"/>
            <van-popup v-model="showPickerHJArea" position="bottom">
                <van-picker :columns="areaHJList" show-toolbar value-key="title" @cancel="showPickerHJArea = false"
                            @confirm="onConfirmHJArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="userInfo.hjdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="组织机构代码(社会统一信用代码):" type="textarea" required v-model="userInfo.zzjgdm"
                       placeholder="请输入组织机构代码" rows="1" autosize clearable/>
            <van-field required  label="法定代表人" v-model="userInfo.fddbr" placeholder="请输入法定代表人"
                       input-align="right"/>
            <van-field required label="联系电话" v-model="userInfo.lxdh" placeholder="请输入联系电话"
                       input-align="right"/>
            <!--拟落户地址-->
            <van-field v-model="userInfo.nlhdz1" label="拟落户地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerLHProvince = true"/>
            <van-popup v-model="showPickerLHProvince" position="bottom">
                <van-picker :columns="provinceLHList" show-toolbar value-key="title"
                            @cancel="showPickerLHProvince = false"
                            @confirm="onConfirmLHProvince"/>
            </van-popup>
            <van-field v-model="userInfo.nlhdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerLHCity = true" v-if="LHCityShow"/>
            <van-popup v-model="showPickerLHCity" position="bottom">
                <van-picker :columns="cityLHList" show-toolbar value-key="title" @cancel="showPickerLHCity = false"
                            @confirm="onConfirmLHCity"/>
            </van-popup>
            <van-field v-model="userInfo.nlhdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerLHArea = true" v-if="LHAreaShow"/>
            <van-popup v-model="showPickerLHArea" position="bottom">
                <van-picker :columns="areaLHList" show-toolbar value-key="title" @cancel="showPickerLHArea = false"
                            @confirm="onConfirmLHArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="userInfo.nlhdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="所属派出所:" type="textarea" required v-model="userInfo.sspcs"
                       placeholder="请输入拟落户所属派出所" rows="1" autosize clearable/>
        </van-cell-group>
        <!--户口协管人基本信息-------------------------------------------------------------------->
        <p class="title">户口协管人基本信息</p>
        <van-cell-group>
            <van-field required  label="姓名" v-model="userInfo.xgr_xm"
                       input-align="right" />
            <van-field required readonly clickable label="性别" v-model="userInfo.xgr_xbmc" placeholder="请选择"
                       @click="showPickerSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerSex" position="bottom">
                <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex = false"
                            @confirm="onConfirmSex"/>
            </van-popup>
            <van-field required  label="公民身份证号" v-model="userInfo.xgr_gmsfhm"
                       input-align="right" />
            <van-field required  label="联系电话" v-model="userInfo.xgr_lxdh"
                       input-align="right" />
        </van-cell-group>

    </div>
</template>

<script>
    import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
    import { dateToString } from '@/utils/time'
    import { baseApiMap } from '@/api/base'
    import { idCardRegex, phoneRegex } from '@/utils/regex'
    import { forEachObj } from '@/utils/check'

    export default {
        components: {
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        props: {
            applicationInfo: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                userInfo: {
                    // xm: this.$cookie.getUser().realName,
                    // xb: '',
                    // csrq: '',
                    // gmsfhm: this.$cookie.getUser().idNum.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2'),

                    csmc:"",//场所名称
                    csdz:"",//场所地址
                    zzjgdm:"",//组织机构代码
                    fddbr:"",//法人
                    lxdh:"",//联系电话
                    nlhdz:"",//拟落户地址
                    sspcs:"",//所属派出所
                    xgr_xm:"",//协管人姓名
                    xgr_xb:"",//协管人性别
                    xgr_xbmc:"",
                    xgr_gmsfhm:"",//协管人身份证号
                    xgr_lxdh:"",//协管人联系电话


                    hjdz1: '',
                    hjdz2: '',
                    hjdz3: '',
                    hjdzxxdz: '',
                    hjsspcs: '',
                    sjjzdz3: '',
                    sjjzdzxxdz: '',
                    sjsspcs: '',
                    nlhdzlx: '',
                    nlhdz1: '',
                    nlhdz2: '',
                    nlhdz3: '',
                    nlhdzxxdz: '',
                },
                sexList: [],
                showPickerSex: false, // 是否显示性别选择框
                provinceList: [], // 省
                cityHJList: [], // 户籍市
                areaHJList: [], // 户籍区县
                showPickerHJProvince: false, // 是否显示户籍省选择框
                HJCityShow: false, // 是否显示户籍市
                HJAreaShow: false, // 是否显示户籍区县
                showPickerHJCity: false, // 是否显示户籍市选择框
                showPickerHJArea: false, // 是否显示户籍区县选择框
                citySJList: [], // 实际居住地市
                areaSJList: [], // 实际居住地区县
                showPickerSJProvince: false, // 是否显示实际居住地省选择框
                SJCityShow: false, // 是否显示实际居住地市
                SJAreaShow: false, // 是否显示实际居住地区县
                showPickerSJCity: false, // 是否显示实际居住地市选择框
                showPickerSJArea: false, // 是否显示实际居住地区县选择框
                showPickernlhdlx: false, // 是否显示拟落户地址类型选择框
                provinceLHList: [{"title": '湖北省', "val": '420000'}], // 拟落户地址省
                cityLHList: [], // 拟落户地址市
                areaLHList: [], // 拟落户地址区县
                showPickerLHProvince: false, // 是否显示拟落户地址省选择框
                LHCityShow: false, // 是否显示拟落户地址市
                LHAreaShow: false, // 是否显示拟落户地址区县
                showPickerLHCity: false, // 是否显示拟落户地址市选择框
                showPickerLHArea: false, // 是否显示拟落户地址区县选择框

            }
        },
        mounted() {
            this.getProvinceData()
            this.getSexList()
        },
        methods: {
            /**
             * 加载性别
             */
            getSexList() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
                    let arr = [];
                    if (response.data.succ = true) {
                        let arrSex = response.data.data;
                        for (let i = 0; i < arrSex.length; i++) {
                            arr.push({ "name": arrSex[i].title, "key": arrSex[i].val })
                        }
                    }
                    this.$nextTick(() => {
                        this.sexList = arr
                    })
                }).catch(err => {

                })
            },
            /**
             * 获取省
             */
            async getProvinceData() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.provinceList = arr
                } catch (error) {
                    Toast('服务器运行失败')
                    console.log(error);
                }
            },
            /**
             * 获取市
             */
            async getHJCityData(value) {
                try {
                    this.cityHJList = []
                    this.areaHJList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityHJList = arr
                    if (this.cityHJList.length > 0) {
                        this.HJCityShow = true
                    } else {
                        this.HJCityShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取地区
             */
            async getHJAreaData(value) {
                try {
                    this.areaHJList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaHJList = arr
                    if (this.areaHJList.length > 0) {
                        this.HJAreaShow = true
                    } else {
                        this.HJAreaShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 选择性别
             */
            onConfirmSex(value) {
                this.userInfo.xgr_xbmc = value.name
                this.userInfo.xgr_xb = value.key
                this.showPickerSex = false
            },
            /**
             * 选择户籍地址省
             */
            onConfirmHJProvince(value) {
                this.userInfo.hjdz1 = value.title
                this.userInfo.hjdz2 = ''
                this.userInfo.hjdz3 = ''
                this.showPickerHJProvince = false
                this.getHJCityData(value.val)
            },
            /**
             * 选择户籍地址市
             */
            onConfirmHJCity(value) {
                this.showPickerHJCity = false
                this.userInfo.hjdz2 = value.title
                this.userInfo.hjdz3 = ''
                this.getHJAreaData(value.val)
            },
            /**
             * 选择户籍区县
             */
            onConfirmHJArea(value) {
                this.showPickerHJArea = false
                this.userInfo.hjdz3 = value.title
            },
            /**
             * 获取实际居住地址市
             */
            async getSJCityData(value) {
                try {
                    this.citySJList = []
                    this.areaSJList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.citySJList = arr
                    if (this.citySJList.length > 0) {
                        this.SJCityShow = true
                    } else {
                        this.SJCityShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取实际居住地址区县
             */
            async getSJAreaData(value) {
                try {
                    this.areaSJList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaSJList = arr
                    if (this.areaSJList.length > 0) {
                        this.SJAreaShow = true
                    } else {
                        this.SJAreaShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 选择实际居住地址省
             */
            onConfirmSJProvince(value) {
                this.userInfo.sjjzdz1 = value.title
                this.userInfo.sjjzdz2 = ''
                this.userInfo.sjjzdz3 = ''
                this.showPickerSJProvince = false
                this.getSJCityData(value.val)
            },
            /**
             * 选择实际居住地址市
             */
            onConfirmSJCity(value) {
                this.showPickerSJCity = false
                this.userInfo.sjjzdz2 = value.title
                this.userInfo.sjjzdz3 = ''
                this.getSJAreaData(value.val)
            },
            /**
             * 选择实际居住地址区县
             */
            onConfirmSJArea(value) {
                this.showPickerSJArea = false
                this.userInfo.sjjzdz3 = value.title
            },

            /**
             * 获取拟落户地址市
             */
            async getLHCityData(value) {
                try {
                    this.cityLHList = []
                    this.areaLHList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityLHList = arr
                    if (this.cityLHList.length > 0) {
                        this.LHCityShow = true
                    } else {
                        this.LHCityShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取拟落户地址区县
             */
            async getLHAreaData(value) {
                try {
                    this.areaLHList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaLHList = arr
                    if (this.areaLHList.length > 0) {
                        this.LHAreaShow = true
                    } else {
                        this.LHAreaShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 选择拟落户地址省
             */
            onConfirmLHProvince(value) {
                this.userInfo.nlhdz1 = value.title
                this.userInfo.nlhdz2 = ''
                this.userInfo.nlhdz3 = ''
                this.showPickerLHProvince = false
                this.getLHCityData(value.val)
            },
            /**
             * 选择拟落户地址市
             */
            onConfirmLHCity(value) {
                this.showPickerLHCity = false
                this.userInfo.nlhdz2 = value.title
                this.userInfo.nlhdz3 = ''
                this.getLHAreaData(value.val)
            },
            /**
             * 选择拟落户地址区县
             */
            onConfirmLHArea(value) {
                this.showPickerLHArea = false
                this.userInfo.nlhdz3 = value.title
            },
            /**
             * 校验数据
             */
            validApplication() {
                forEachObj(this.userInfo) // 去掉空格
                if (!this.userInfo.csmc) {
                    Toast('请输入场所名称')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.hjdz3) {
                    Toast('请选择场所地址')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.hjdzxxdz) {
                    Toast('请输入场所区划内详细地址')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.zzjgdm) {
                    Toast('请输入组织机构代码')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.fddbr) {
                    Toast('请输入法定代表人')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.lxdh) {
                    Toast('请输入联系电话')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!phoneRegex(this.userInfo.lxdh)) {
                    Toast('联系电话输入有误')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.nlhdz3) {
                    Toast('请选择拟落户地址')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.nlhdzxxdz) {
                    Toast('请输入拟落户详细地址')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.sspcs) {
                    Toast('请输入所属派出所')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.xgr_xm) {
                    Toast('请输入协管人姓名')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.xgr_xb) {
                    Toast('请选择协管人性别')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.xgr_gmsfhm) {
                    Toast('请输入协管人公民身份证号')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!idCardRegex(this.userInfo.xgr_gmsfhm)) {
                    Toast('公民身份证号输入有误')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!this.userInfo.xgr_lxdh) {
                    Toast('请输入协管人联系电话')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                if (!phoneRegex(this.userInfo.xgr_lxdh)) {
                    Toast('协管人联系电话输入有误')
                    this.$emit('getApplicationPersonInfo1', false)
                    return
                }
                this.applicationInfo.csmc = this.userInfo.csmc
                this.applicationInfo.zzjgdm = this.userInfo.zzjgdm
                this.applicationInfo.fddbr = this.userInfo.fddbr
                this.applicationInfo.lxdh = this.userInfo.lxdh
                this.applicationInfo.csdz = this.userInfo.hjdz1 + this.userInfo.hjdz2 + this.userInfo.hjdz3 + this.userInfo.hjdzxxdz
                this.applicationInfo.nlhdz = this.userInfo.nlhdz1 + this.userInfo.nlhdz2 + this.userInfo.nlhdz3 + this.userInfo.nlhdzxxdz
                this.applicationInfo.sspcs = this.userInfo.sspcs
                this.applicationInfo.xgr_xm = this.userInfo.xgr_xm
                this.applicationInfo.xgr_xb = this.userInfo.xgr_xb
                this.applicationInfo.xgr_gmsfhm = this.userInfo.xgr_gmsfhm
                this.applicationInfo.xgr_lxdh = this.userInfo.xgr_lxdh
                this.applicationInfo.sqly = ''
                console.log(JSON.stringify(this.applicationInfo))
                this.$emit('getApplicationPersonInfo1', true)
                return
            }
        }
    }
</script>

<style>
    .van-field__label {
        width: 100px;
    }
</style>
<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
